import { defineNuxtPlugin } from '#app';
import {VueCsvImportPlugin} from "vue-csv-import";


export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueCsvImportPlugin)
});